import { CreateApplicationFromTokenInput, CreateApplicationFromTokenResponse } from '../interfaces/create-application-from-token';

import { Resource } from 'modules/core/base-resource';
import { TokenData } from '../interfaces/token-data';
import { TokenResponse } from '../interfaces/token-response';
import httpResource from '../../../core/http-resource';

class ApplicationsResource extends Resource {
  constructor() {
    super('application', httpResource);
  }

  public getToken(championshipId: number, teamId: number): Promise<TokenResponse> {
    return this.child('token').get({ championshipId, teamId });
  }

  public createFromToken(data: CreateApplicationFromTokenInput): Promise<CreateApplicationFromTokenResponse> {
    return this.child('create-from-token').post(data);
  }

  public decodeToken(token: string): Promise<TokenData> {
    return this.child('decode-token').get({ token });
  }
}

const applicationsResource = new ApplicationsResource();
export default applicationsResource;
